import React from 'react';
import { downloadUserAttachment } from '../../api/Api';
import { useLoadingContext } from '../../contexts/LoadingContext';
import { getFileType } from '../../utilities/parsers';
import ConciliacionForm from './ConciliacionForm';
import Divider from '../Divider';

const ConciliacionTab = ({
  orderNumber,
  order,
  fileToUploadProg,
  setFileToUploadProg,
  fileToUploadTrans,
  setFileToUploadTrans,
  fileToUploadTest,
  setFileToUploadTest,
  fileDescriptionProg,
  setFileDescriptionProg,
  fileDescriptionTrans,
  setFileDescriptionTrans,
  fileDescriptionTest,
  setFileDescriptionTest,
  setFileType,
  handleUpload,
  downloadFile,
  files,
  profile,
  orderId,
}) => {

  // Helper para obtener icono de tipo de archivo
  const getFileIcon = (fileName) => {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    const iconMap = {
      pdf: 'fas fa-file-pdf has-text-danger',
      doc: 'fas fa-file-word has-text-primary',
      docx: 'fas fa-file-word has-text-primary',
      xls: 'fas fa-file-excel has-text-success',
      xlsx: 'fas fa-file-excel has-text-success',
      jpg: 'fas fa-file-image has-text-warning',
      jpeg: 'fas fa-file-image has-text-warning',
      png: 'fas fa-file-image has-text-warning',
      zip: 'fas fa-file-archive has-text-info',
      rar: 'fas fa-file-archive has-text-info',
      txt: 'fas fa-file-alt has-text-grey',
      default: 'fas fa-file has-text-grey'
    };
    return iconMap[extension] || iconMap.default;
  };

  // Helper para badge de tipo de adjunto
  const getAttachmentTypeBadge = (typeName) => {
    const typeMap = {
      'Programación': 'is-info',
      'Transmisión': 'is-warning', 
      'Testigo': 'is-success',
      'General': 'is-primary'
    };
    
    const badgeClass = typeMap[typeName] || 'is-light';
    
    return (
      <span className={`tag ${badgeClass} is-light is-size-6`}>
        {typeName}
      </span>
    );
  };

  return (
    <div>
      {/* Información Básica de la Orden */}
      <div className="card mb-4">
        <header className="card-header">
          <p className="card-header-title">
            <span className="icon mr-2">
              <i className="fas fa-info-circle"></i>
            </span>
            Información de la Orden
          </p>
        </header>
        <div className="card-content">
          <div className="columns">
            {/* Número de Orden */}
            <div className="column is-half">
              <div className="field">
                <label className="label has-text-weight-semibold">
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-hashtag"></i>
                    </span>
                    <span>Número de Orden</span>
                  </span>
                </label>
                <div className="field is-grouped">
                  <div className="control is-expanded">
                    <input
                      className="input has-text-centered has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={orderNumber[0]}
                    />
                  </div>
                  <div className="control">
                    <span className="button is-static">-</span>
                  </div>
                  <div className="control is-expanded">
                    <input
                      className="input has-text-centered has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={orderNumber[1]}
                    />
                  </div>
                  <div className="control">
                    <span className="button is-static">-</span>
                  </div>
                  <div className="control is-expanded">
                    <input
                      className="input has-text-centered has-text-weight-semibold"
                      type="text"
                      disabled={true}
                      value={orderNumber[2]}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Anunciante */}
            <div className="column is-half">
              <div className="field">
                <label className="label has-text-weight-semibold">
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fas fa-bullhorn"></i>
                    </span>
                    <span>Anunciante</span>
                  </span>
                </label>
                <div className="control">
                  <input
                    className="input has-text-weight-semibold"
                    type="text"
                    disabled={true}
                    value={order['Anunciante']}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección de Formularios - Solo para No Admin */}
      {!profile.is_admin && (
        <div className="columns is-multiline mb-4">
          {/* Programados */}
          <div className="column is-full">
            <div className="card">
              <header className="card-header has-background-info-light">
                <p className="card-header-title has-text-info-dark">
                  <span className="icon mr-2">
                    <i className="fas fa-calendar-check"></i>
                  </span>
                  Programados
                </p>
              </header>
              <div className="card-content">
                <ConciliacionForm
                  fileToUpload={fileToUploadProg}
                  setFileToUpload={setFileToUploadProg}
                  fileDescription={fileDescriptionProg}
                  setFileDescription={setFileDescriptionProg}
                  fileType={1}
                  setFileType={setFileType}
                  handleUpload={handleUpload}
                  profile={profile}
                />
              </div>
            </div>
          </div>

          {/* Transmitidos */}
          <div className="column is-full">
            <div className="card">
              <header className="card-header has-background-warning-light">
                <p className="card-header-title has-text-warning-dark">
                  <span className="icon mr-2">
                    <i className="fas fa-broadcast-tower"></i>
                  </span>
                  Transmitidos
                </p>
              </header>
              <div className="card-content">
                <ConciliacionForm
                  fileToUpload={fileToUploadTrans}
                  setFileToUpload={setFileToUploadTrans}
                  fileDescription={fileDescriptionTrans}
                  setFileDescription={setFileDescriptionTrans}
                  fileType={2}
                  setFileType={setFileType}
                  handleUpload={handleUpload}
                  profile={profile}
                />
              </div>
            </div>
          </div>

          {/* Testigos */}
          <div className="column is-full">
            <div className="card">
              <header className="card-header has-background-success-light">
                <p className="card-header-title has-text-success-dark">
                  <span className="icon mr-2">
                    <i className="fas fa-video"></i>
                  </span>
                  Testigos
                </p>
              </header>
              <div className="card-content">
                <ConciliacionForm
                  fileToUpload={fileToUploadTest}
                  setFileToUpload={setFileToUploadTest}
                  fileDescription={fileDescriptionTest}
                  setFileDescription={setFileDescriptionTest}
                  fileType={3}
                  setFileType={setFileType}
                  handleUpload={handleUpload}
                  profile={profile}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tabla de Adjuntos Cargados */}
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">
            <span className="icon mr-2">
              <i className="fas fa-folder-open"></i>
            </span>
            Adjuntos Cargados
            <span className="tag is-light ml-2">
              {files.length} archivo{files.length !== 1 ? 's' : ''}
            </span>
          </p>
        </header>
        <div className="card-content p-0">
          {files.length === 0 ? (
            <div className="has-text-centered py-6">
              <span className="icon-text has-text-grey">
                <span className="icon is-large mr-3">
                  <i className="fas fa-inbox fa-2x"></i>
                </span>
                <span className="is-size-5">No hay archivos cargados</span>
              </span>
              <p className="has-text-grey mt-2">
                Los archivos que subas aparecerán aquí
              </p>
            </div>
          ) : (
            <div className="table-container">
              <table className="table is-bordered is-fullwidth is-hoverable mb-0">
                <thead>
                  <tr className="has-background-light">
                    <th>
                      <span className="icon-text">
                        <span className="icon is-small mr-2">
                          <i className="fas fa-file"></i>
                        </span>
                        <span>Archivo</span>
                      </span>
                    </th>
                    <th>
                      <span className="icon-text">
                        <span className="icon is-small mr-2">
                          <i className="fas fa-tag"></i>
                        </span>
                        <span>Tipo</span>
                      </span>
                    </th>
                    <th>
                      <span className="icon-text">
                        <span className="icon is-small mr-2">
                          <i className="fas fa-align-left"></i>
                        </span>
                        <span>Descripción</span>
                      </span>
                    </th>
                    <th>
                      <span className="icon-text">
                        <span className="icon is-small mr-2">
                          <i className="fas fa-layer-group"></i>
                        </span>
                        <span>Categoría</span>
                      </span>
                    </th>
                    <th>
                      <span className="icon-text">
                        <span className="icon is-small mr-2">
                          <i className="fas fa-broadcast-tower"></i>
                        </span>
                        <span>Medio</span>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {files.map((file, index) => (
                    <tr key={index} className="is-size-6">
                      <td>
                        <div className="is-flex is-align-items-center">
                          <span className={`icon mr-2 ${getFileIcon(file.name)}`}>
                            <i className={getFileIcon(file.name)}></i>
                          </span>
                          <button 
                            className="button is-ghost is-normal has-text-weight-semibold" 
                            onClick={(e) => downloadFile(e, file)}
                            title="Descargar archivo"
                          >
                            {file.name}
                          </button>
                        </div>
                      </td>
                      <td>
                        <span className="tag is-light is-medium">
                          {getFileType(file?.name)}
                        </span>
                      </td>
                      <td className="has-text-weight-semibold">
                        {file.description || 
                          <span className="has-text-grey-light is-italic">Sin descripción</span>
                        }
                      </td>
                      <td>
                        {getAttachmentTypeBadge(file.type_name)}
                      </td>
                      <td>
                        <span className="tag is-info is-light is-medium">
                          {file.media}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConciliacionTab;